<template>
  <figure class="m-0">
    <!-- Generator: Adobe Illustrator 24.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
    <svg ref="svg" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 410 216" style="enable-background:new 0 0 410 216;" xml:space="preserve">
    <rect class="field-bg" width="410" height="216"/>
    <g id="Field">
        <circle class="field-lines" cx="371.5" cy="108" r="3.5"/>
        <circle class="field-lines" cx="38.5" cy="108" r="3.5"/>
        <path class="field-lines" d="M397,0H13H0v13v31v29v70v29v31v13h13h384h13v-13v-31v-29V73V44V13V0H397z M407,3v6.6c-3.2-0.9-5.8-3.4-6.7-6.6H407z M206.5,111.1c1.2-0.6,2-1.8,2-3.1s-0.8-2.6-2-3.1V73c18.6,0.8,33.5,16.2,33.5,35s-14.9,34.2-33.5,35V111.1z M3,3h6.6C8.7,6.2,6.2,8.8,3,9.7V3z M23,143V73H3V47h51v27.5v0v67V169H3v-26H23z M3,140V76h17v64H3z M3,213v-6.6c3.2,0.9,5.8,3.4,6.7,6.6H3zM203.5,104.9c-1.2,0.6-2,1.8-2,3.1s0.8,2.6,2,3.1V143c-18.6-0.8-33.5-16.2-33.5-35s14.9-34.2,33.5-35V104.9z M203.5,70c-20.3,0.8-36.5,17.5-36.5,38s16.2,37.2,36.5,38v67H12.8c-0.9-4.8-4.8-8.6-9.8-9.7V172h54v-32.6c4.1-3.1,7.6-7.1,10.1-11.7c1.6-2.9,2.9-6.1,3.7-9.3c1.7-6.9,1.7-14,0-20.9c-0.8-3.3-2.1-6.4-3.7-9.3c-2.5-4.6-5.9-8.5-10.1-11.7V44H3V12.8C7.8,11.9,11.6,8,12.7,3h190.8V70z M57,135.6V80.4c3,2.6,5.5,5.8,7.4,9.3c1.5,2.7,2.6,5.6,3.4,8.6c1.6,6.4,1.6,13,0,19.4c-0.8,3-1.9,5.9-3.4,8.6C62.5,129.8,60,133,57,135.6z M407,213h-6.6c0.9-3.2,3.4-5.8,6.6-6.7V213z M387,73v70h20v26h-51v-27.5v0v-67V47h51v26H387z M407,76v64h-17V76H407z M353,44v32.6c-4.1,3.1-7.6,7.1-10.1,11.7c-1.6,2.9-2.9,6.1-3.7,9.3c-1.7,6.9-1.7,14,0,20.9c0.8,3.3,2.1,6.4,3.7,9.3c2.5,4.6,5.9,8.5,10.1,11.7V172h54v31.2c-4.8,0.9-8.6,4.8-9.7,9.8H206.5v-67c20.3-0.8,36.5-17.5,36.5-38s-16.2-37.2-36.5-38V3h190.7c0.9,4.8,4.8,8.6,9.8,9.7V44H353z M353,80.4v55.2c-3-2.6-5.5-5.8-7.4-9.3c-1.5-2.7-2.6-5.6-3.4-8.6c-1.6-6.4-1.6-13,0-19.4c0.8-3,1.9-5.9,3.4-8.6C347.5,86.2,350,83,353,80.4z"/>
    </g>
    <g class="player-position goalkeeper">
        <g class="position">
            <circle lass="position-circle" cx="21" cy="108" r="7.5"/>
            <path class="position-letter" d="M39.4,106.2c-0.1-0.5-0.4-0.9-0.8-1.1s-0.8-0.4-1.4-0.4c-0.8,0-1.4,0.3-1.9,0.9c-0.5,0.6-0.7,1.4-0.7,2.5
            c0,1.1,0.2,1.9,0.7,2.5s1.1,0.9,1.9,0.9c0.7,0,1.3-0.2,1.7-0.6c0.4-0.4,0.6-0.9,0.6-1.5h-2.2v-1.6h4.3v1.3c0,0.9-0.2,1.7-0.6,2.3c-0.4,0.6-0.9,1.1-1.6,1.5s-1.4,0.5-2.3,0.5c-1,0-1.8-0.2-2.5-0.6c-0.7-0.4-1.3-1-1.7-1.8c-0.4-0.8-0.6-1.7-0.6-2.8c0-1.1,0.2-2,0.6-2.8c0.4-0.8,1-1.4,1.7-1.8c0.7-0.4,1.5-0.6,2.4-0.6c0.8,0,1.5,0.1,2.1,0.4c0.6,0.3,1.1,0.7,1.5,1.2c0.4,0.5,0.6,1.1,0.7,1.8H39.4z"/>
        </g>
    </g>
    <g class="player-position defense">
        <g class="position">
            <circle class="position-circle" cx="113" cy="83.7" r="7.5"/>
            <path class="position-letter" d="M128.1,88.8h-3.6V78.6h3.6c1,0,1.9,0.2,2.6,0.6c0.7,0.4,1.3,1,1.7,1.7c0.4,0.8,0.6,1.7,0.6,2.7
            c0,1.1-0.2,2-0.6,2.7c-0.4,0.8-1,1.3-1.7,1.8C130,88.6,129.1,88.8,128.1,88.8z M126.7,87h1.4c1,0,1.7-0.3,2.2-0.8c0.5-0.5,0.7-1.3,0.7-2.5c0-1.1-0.2-2-0.7-2.5s-1.2-0.8-2.2-0.8h-1.4V87z"/>
        </g>
        <g class="position">
            <circle class="position-circle" cx="113" cy="132.3" r="7.5"/>
            <path class="position-letter" d="M128.1,137.4h-3.6v-10.2h3.6c1,0,1.9,0.2,2.6,0.6c0.7,0.4,1.3,1,1.7,1.7c0.4,0.8,0.6,1.7,0.6,2.7
            c0,1.1-0.2,2-0.6,2.7c-0.4,0.8-1,1.3-1.7,1.8C130,137.2,129.1,137.4,128.1,137.4z M126.7,135.5h1.4c1,0,1.7-0.3,2.2-0.8c0.5-0.5,0.7-1.3,0.7-2.5c0-1.1-0.2-2-0.7-2.5S129,129,128,129h-1.4V135.5z"/>
        </g>
        <g class="position">
            <circle class="position-circle" cx="113" cy="35.1" r="7.5"/>
            <path class="position-letter" d="M128.1,40.2h-3.6V30h3.6c1,0,1.9,0.2,2.6,0.6c0.7,0.4,1.3,1,1.7,1.7c0.4,0.8,0.6,1.7,0.6,2.7
            c0,1.1-0.2,2-0.6,2.7c-0.4,0.8-1,1.3-1.7,1.8C130,40,129.1,40.2,128.1,40.2z M126.7,38.4h1.4c1,0,1.7-0.3,2.2-0.8c0.5-0.5,0.7-1.3,0.7-2.5c0-1.1-0.2-2-0.7-2.5s-1.2-0.8-2.2-0.8h-1.4V38.4z"/>
        </g>
        <g class="position">
            <circle class="position-circle" cx="113" cy="180.9" r="7.5"/>
            <path class="position-letter" d="M128.1,186h-3.6v-10.2h3.6c1,0,1.9,0.2,2.6,0.6c0.7,0.4,1.3,1,1.7,1.7c0.4,0.8,0.6,1.7,0.6,2.7
            c0,1.1-0.2,2-0.6,2.7c-0.4,0.8-1,1.3-1.7,1.8C130,185.7,129.1,186,128.1,186z M126.7,184.1h1.4c1,0,1.7-0.3,2.2-0.8c0.5-0.5,0.7-1.3,0.7-2.5c0-1.1-0.2-2-0.7-2.5s-1.2-0.8-2.2-0.8h-1.4V184.1z"/>
        </g>
    </g>
    <g class="player-position midfield">
        <g class="position">
            <circle class="position-circle" cx="205" cy="35.1" r="7.5"/>
            <path class="position-letter" d="M216.5,30h2.7l2.8,6.8h0.1l2.8-6.8h2.7v10.2h-2.1v-6.6h-0.1l-2.6,6.6h-1.4l-2.6-6.6h-0.1v6.7h-2.1V30z"/>
        </g>
        <g class="position">
            <circle class="position-circle" cx="205" cy="83.7" r="7.5"/>
            <path class="position-letter" d="M216.5,78.6h2.7l2.8,6.8h0.1l2.8-6.8h2.7v10.2h-2.1v-6.6h-0.1l-2.6,6.6h-1.4l-2.6-6.6h-0.1v6.7h-2.1V78.6z"/>
        </g>
        <g class="position">
            <circle class="position-circle" cx="205" cy="132.3" r="7.5"/>
            <path class="position-letter" d="M216.5,127.2h2.7l2.8,6.8h0.1l2.8-6.8h2.7v10.2h-2.1v-6.6h-0.1l-2.6,6.6h-1.4l-2.6-6.6h-0.1v6.7h-2.1V127.2z"/>
        </g>
        <g class="position">
            <circle class="position-circle" cx="205" cy="180.9" r="7.5"/>
            <path class="position-letter" d="M216.5,175.8h2.7l2.8,6.8h0.1l2.8-6.8h2.7V186h-2.1v-6.6h-0.1l-2.6,6.6h-1.4l-2.6-6.6h-0.1v6.7h-2.1V175.8z"/>
        </g>
    </g>
    <g class="player-position forward">
        <g class="position">
            <circle class="position-circle" cx="296.5" cy="132.3" r="7.5"/>
            <path class="position-letter" d="M308,137.4v-10.2h6.7v1.8h-4.6v2.4h4.1v1.8h-4.1v4.2H308z"/>
        </g>
        <g class="position">
            <circle class="position-circle" cx="296.5" cy="83.7" r="7.5"/>
            <path class="position-letter" d="M308,88.8V78.6h6.7v1.8h-4.6v2.4h4.1v1.8h-4.1v4.2H308z"/>
        </g>
    </g>
    </svg>

  </figure>
</template>

<script>
import positionsLogic from './AthletePositionsLogic';
export default {
    mixins: [ positionsLogic ]
}
</script>